import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { MIN_PASS_LENGTH } from 'shared/utils/forms'

import { resetPasswordConfirm } from 'features/auth/actions'
import { selectAuthCommunication } from 'features/auth/selectors'

const validationSchema = yup.object().shape({
  newPassword: yup.string().min(MIN_PASS_LENGTH, 'minPassLength').required('required'),
  repeatNewPassword: yup
    .string()
    .required('required')
    .oneOf([yup.ref('newPassword'), ''], 'passwordsDoNotMatch'),
})

type UseResetPasswordConfirmProps = {
  onSuccess?: () => void
  token?: string
}

export const useResetPasswordConfirm = ({ onSuccess, token }: UseResetPasswordConfirmProps) => {
  const dispatch = useDispatch()
  const { isLoading, isSuccess, error } = useSelector(selectAuthCommunication, shallowEqual).resetPasswordConfirm
  const formik = useFormik({
    initialValues: {
      newPassword: '',
      repeatNewPassword: '',
    },
    validationSchema,
    onSubmit: values => {
      const data = {
        new_password1: values.newPassword,
        new_password2: values.repeatNewPassword,
        token: token || '',
      }
      dispatch(resetPasswordConfirm({ data, callback: onSuccess }))
    },
  })

  return {
    formik,
    isLoading,
    isSuccess,
    error,
  }
}
